import {Component, inject, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import Invoice from "../../model/invoice.model";
import {AsyncPipe, DatePipe, TitleCasePipe} from "@angular/common";
import {ApplicationConfig, config} from '../../../../config';
import {ButtonComponent} from "../button/button.component";
import {MobileService} from "../../services/mobile.service";
import {AuthService} from "../../services/auth.service";
import Relation from "../../model/relation.model";
import {CurrencyComponent} from "../currency/currency.component";
import {PaymentStatusComponent} from "../payment-status/payment-status.component";
import {downloadInvoice} from "../../functions/downloadInvoice.function";

@Component({
    selector: 'app-invoice-preview',
    imports: [
    DatePipe,
    TitleCasePipe,
    ButtonComponent,
    AsyncPipe,
    CurrencyComponent,
    PaymentStatusComponent
],
    templateUrl: './invoice-preview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './invoice-preview.component.scss'
})
export class InvoicePreviewComponent implements OnInit {
  readonly mobileService: MobileService = inject(MobileService);
  private readonly authService: AuthService = inject(AuthService);

  @Input() invoice!: Invoice;
  @Input() logo: string = '/logo.png'
  public config: ApplicationConfig = config;
  public isBusiness: boolean | null = null;

  public ngOnInit() {
    this.authService.getActiveRelation().subscribe((relation: Relation | null) => {
      if (relation === null) {
        return;
      }

      this.isBusiness = relation.is_business;
    });
  }

  public download(): void {
    downloadInvoice(this.invoice);
  }
}
